<div class="communication-status flex-row align-items-center">
  {{ this.getTranslate() | translate }}
  <cam-font-icon name="infos2" type="xs"></cam-font-icon>
</div>
